import { ReactComponent as TimeIcon1 } from 'public/assets/order/icons/time-fast.svg'
import { ReactComponent as TimeIcon2 } from 'public/assets/order/icons/time.svg'
import { ReactComponent as TimeIcon3 } from 'public/assets/order/icons/time-cal.svg'
import { ReactComponent as TimeIcon4 } from 'public/assets/order/icons/time-hourglass.svg'

export type CustomFormSource = 'newsletter' | 'cml'

export const contentData: {
  [key in CustomFormSource | 'default']?: {
    title: string
    description: string
    ctaTitle: string
    showSidebar: boolean
    formName: string
    pardotUrl?: string
  }
} = {
  default: {
    title: 'Book a Demo',
    description:
      'See what Pepper Content can do for you in a short 20min call and discover the new way of doing content marketing.',
    ctaTitle: 'Continue',
    showSidebar: true,
    formName: 'Book a demo'
  },
  newsletter: {
    title: 'Get access to insightful blog and articles',
    description:
      'Valuable content to help you rev your content marketing engine, straight to your inbox',
    ctaTitle: 'Sign Up',
    showSidebar: false,
    formName: 'Newsletter Subscription'
  },
  cml: {
    title: 'Learn about the state of marketing and content',
    description:
      'Get global expert-backed insights into content, SEO, product-led marketing, and more.',
    ctaTitle: 'Sign Up',
    showSidebar: false,
    formName: 'Content Marketing Leaders'
  }
}

export const numEmployeesOptions = [
  { label: 'Number of employees', value: '' },
  { label: '0-50', value: '0-50' },
  { label: '50-1000', value: '50-1000' },
  { label: '1000-5000', value: '1000-5000', isEnterprise: true },
  { label: '5000+', value: '5000+', isEnterprise: true }
]

export const useCaseOptions = [
  {
    key: 'Increase productivity for in-house teams with AI writing and automation',
    value:
      'Increase productivity for in-house teams with AI writing and automation',
    metadata: { showContentCategory: false, showStrategySolution: false }
  },
  {
    key: 'Scale content writing, localization, and videos with our expert network',
    value:
      'Scale content writing localization and videos with our expert network',
    metadata: { showContentCategory: true, showStrategySolution: false }
  },
  {
    key: "Improve your website's ranking and increase organic traffic",
    value: "Improve your website's ranking and increase organic traffic",
    metadata: { showContentCategory: false, showStrategySolution: false }
  },
  {
    key: 'Reduce CAC by scaling organic marketing efforts strategically',
    value: 'Reduce CAC by scaling organic marketing efforts strategically',
    metadata: { showContentCategory: false, showStrategySolution: true }
  }
]

export const categories = [
  {
    id: 1,
    title:
      'Content writing (Long form blogs, Ebooks, Whitepapers, Infographics, etc)',
    value: 'text'
    // description:
    //   'Get anything written from a cover letter or a researched case study.',
    // image: '/assets/navigation/content-writing-icon.svg'
  },
  {
    id: 2,
    title: 'Video Creation and Production ',
    value: 'video'
    // description:
    //   'Get high quality design services tailored for your requirements.',
    // image: '/assets/navigation/design-service-icon.svg'
  },
  {
    id: 3,
    title: 'Language and Translation',
    value: 'vernacular'
    // description: `Editing, Translations and Subtitling in more than ${LANGUAGES.value} languages.`,
    // image: '/assets/navigation/language-service-icon.svg'
  }
]

export const budgetUSD = [
  { label: 'Less than $25,000', value: 'Less than $25,000' },
  { label: '$25,000 - $100,000', value: '$25,000 - $100,000' },
  { label: '$100,000 - $300,000', value: '$100,000 - $300,000' },
  { label: '$300,000 and Above', value: '$300,000 and Above' }
]

export const requirementTimeline = [
  {
    label: 'Right away',
    value: 'Right away',
    icon: TimeIcon1
  },
  {
    label: 'In next 30 days',
    value: 'In next 30 days',
    icon: TimeIcon2
  },
  {
    label: 'After 30 days',
    value: 'After 30 days',
    icon: TimeIcon3
  },
  {
    label: 'Not yet decided',
    value: 'Not yet decided',
    icon: TimeIcon4
  }
]

export const strategySolutions = [
  'I’d like to see some insights and data analysis',
  'I need a dedicated content strategy partner to work with us'
]
